import {Component, Inject } from '@angular/core';


@Component({
  templateUrl: 'userDialog.html',
})
export class userDialog {
}
 